<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card
          titleIcon="FilterIcon"
          ref="filterCard"
          title="Advanced Filters"
          class="user-list-filters mb-8"
          :collapse-action="true"
        >
          <div class="vx-row">
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">General</label>

              <vs-input
                type="search"
                placeholder="Search.."
                v-model="filters['search']"
                class="mb-4 md:mb-0 w-full"
              />
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Frequency</label>
              <v-select
                :clearable="true"
                placeholder=""
                v-model="filters['frequency']"
                :options="frequencies"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              ></v-select>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Departments</label>
              <v-select
                :clearable="true"
                placeholder=""
                v-model="filters['departments']"
                :options="departments"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                label="name"
                :reduce="(dept) => dept.id"
                multiple
                :closeOnSelect="false"
              ></v-select>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Staff</label>
              <v-select
                :clearable="true"
                v-model="filters['staff']"
                name="assignee"
                placeholder=""
                label="name"
                :reduce="(option) => option.id"
                :options="staffs"
                multiple
                :closeOnSelect="false"
                :searchable="true"
                :key="'staff-dropdown'"
                @search="onSearch"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              >
                <template slot="no-options">
                  type to search staff
                </template></v-select
              >
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button
                class="float-right mr-4"
                size="small"
                color="danger"
                type="border"
                icon-pack="feather"
                v-on:click="filters = {}"
                >CLEAR</vs-button
              >
            </div>
          </div>
        </vx-card>

        <vx-card title="Tasks" class="pt-1">
          <div slot="no-body" class="mt-4">
            <!-- tasks Table -->
            <vs-table
              :data="tasks"
              stripe
              class="table-dark-inverted table-auto vs-con-loading__container"
            >
              <template slot="thead">
                <vs-td>Code</vs-td>
                <vs-th>Task</vs-th>
                <vs-th>Template</vs-th>
                <vs-th>Users</vs-th>
                <vs-th>Departments</vs-th>
                <vs-th>Due Date</vs-th>
                <vs-th>Status</vs-th>
                <vs-th class="text-xs">ACTION</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr v-for="task in data" :key="task.id">
                  <vs-td>{{ task.code }}</vs-td>
                  <vs-td>{{ task.scheduled_task_schedule.name }}</vs-td>
                  <vs-td>{{
                    task.scheduled_task_schedule.scheduled_task_template.name
                  }}</vs-td>
                  <vs-td>{{
                    task.staff
                      .map((item) => item.name)
                      .join(", ")
                  }}</vs-td>
                  <vs-td>{{
                    task.departments
                      .map((item) => item.name)
                      .join(", ")
                  }}</vs-td>
                  <vs-td>{{ task.due_date ? task.due_date  : 'N/A' }}</vs-td>
                  <vs-td>{{ task.status }}</vs-td>
                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="Complete Task" position="top">
                        <vs-button
                          class="mr-2"
                          @click.stop="onClickViewTask(task.id)"
                          size="small"
                          color="primary"
                          type="border"
                          icon-pack="feather"
                          icon="icon-eye"
                        ></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="meta.last_page ? meta.last_page : 0"
              v-model="page"
              class="p-5"
            ></vs-pagination>
          </div>
        </vx-card>
        <DetailViewPopUp ref="detailViewPopUp" />
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import profile from "@/apis/profile.js";
const ScheduledTasksRepository = RepositoryFactory.get("scheduled_tasks");
const DepartmentsRepository = RepositoryFactory.get("departments");
const DropDownRepository = RepositoryFactory.get("drop_down");
const StaffRepository = RepositoryFactory.get("staff");
import vSelect from "vue-select";
import Filter from "@/mixins/filter";
import { defaultPagination, perPageList } from "@/constants/config";
import DetailViewPopUp from "@/components/popups/scheduled-tasks/DetailViewPopUp.vue";
export default {
  name: "task-instance",
  data() {
    return {
      tasks: [],
      filters: {},
      meta: {},
      page: 1,
      total: 0,
      current_user: {},
      perPage: defaultPagination,
      descriptionItems: perPageList,
      frequencies: [],
      departments: [],
      allocations: [],
      statuses: [],
      staffs: [],
    };
  },
  mixins: [Filter],
  components: {
    "v-select": vSelect,
    DetailViewPopUp,
  },
  methods: {
    async fetchTasks() {
      try {
        const response =
          await ScheduledTasksRepository.getCompletedTaskInstances(
            this.filterQuery,
            this.perPage,
            this.page
          );
          
        this.tasks = response.data.data || response.data;
        this.meta = response.data.meta;
      } catch (error) {}
    },
    onClickViewTask(id) {
      this.$refs.detailViewPopUp.openPopup(id);
    },
    filterQueryUpdate() {
      this.fetchTasks();
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index];
    },
    handleChangePage(page) {
      this.page = page;
      this.fetchTasks();
    },
    async getFrequencies() {
      try {
        const { data } = await ScheduledTasksRepository.frequencies();
        this.frequencies = data.data.sort((a, b) =>
          a.label.localeCompare(b.label)
        );
      } catch (err) {}
    },
    async getAllocations() {
      try {
        const { data } = await ScheduledTasksRepository.allocations();
        this.allocations = data.data.sort((a, b) =>
          a.label.localeCompare(b.label)
        );
      } catch (err) {}
    },
    async getStatuses() {
      try {
        const { data } = await ScheduledTasksRepository.getTaskStatuses();
        this.statuses = data.data.sort((a, b) =>
          a.label.localeCompare(b.label)
        );
      } catch (err) {}
    },
    async getDepartments() {
      const { data } = await DepartmentsRepository.get(" ", "", "", "");
      this.departments = data.data;
    },
    searchStaff: _.debounce(async (loading, search, vm) => {
      const { data } = await DropDownRepository.getStaffList(
        `filter[search]=${search}`
      );
      vm.staffs = data.data;
      loading(false);
    }, 350),
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.searchStaff(loading, search, this);
      }
    },
    async getCurrentUser() {
      try {
        const { data } = (await profile.getCurrentUser()).data;
        this.current_user = data;
      } catch (error) {
      }
    },
    async getCurrentUserDept(id) {
      const { data } = await StaffRepository.getStaff(id);
      this.current_user = data.data;
    },
  },
  async created() {
    await this.getDepartments();
    await this.getCurrentUser();
    await this.fetchTasks();
    await this.getFrequencies();
    await this.getAllocations();
    await this.getStatuses();
  },
  watch: {
    page() {
      this.fetchTasks();
    },
    perPage() {
      this.fetchTasks();
    },
  },
};
</script>
